import { useState } from 'react';
import { faqItems } from '@/mocks/vigorbuy-data';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-4">
          Frequently Asked Questions
        </h2>
        <p className="text-center text-foreground-500 text-sm md:text-base mb-10 max-w-xl mx-auto">
          Everything you need to know about VigorBuy Spreadsheet
        </p>

        <div className="space-y-3">
          {faqItems.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openIdx === idx ? 'bg-primary-100 text-primary-500' : 'bg-background-200 text-foreground-400'}`}>
                  <i className={`text-sm transition-transform ${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              {openIdx === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-foreground-400 text-sm">
            Still have questions?{' '}
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-primary-500 font-semibold hover:text-primary-600 transition-colors cursor-pointer">
              Visit the main VigorBuy Spreadsheet website
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}